
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: t('hero.slide1.title'),
      subtitle: t('hero.slide1.subtitle'),
      image: "https://media.gettyimages.com/id/2231802016/photo/agentic-ai-technology-concept-with-coding-and-digital-gears-artificial-intelligence.jpg?b=1&s=2048x2048&w=0&k=20&c=j6dHhJcrrqMUcSUAIs-Zb65JmrntYJkoD0ovA-LQlUY="
    },
    {
      title: t('hero.slide2.title'),
      subtitle: t('hero.slide2.subtitle'),
      image: "https://media.gettyimages.com/id/1482440776/photo/factory-female-industrial-engineer-working-with-ai-automation-robot-arms-machine-in.jpg?b=1&s=2048x2048&w=0&k=20&c=dKfAloQgb5MfG0aw8AEVL6iSTCOYO0JZfI428e44D68="
    },
    {
      title: t('hero.slide3.title'),
      subtitle: t('hero.slide3.subtitle'),
      image: "https://media.gettyimages.com/id/2224818945/photo/agentic-ai-technology-for-intelligent-digital-automation-systems-man-using-laptop-with-robot.jpg?b=1&s=2048x2048&w=0&k=20&c=77olsTW3L3Ri_HJOvxkThUlX8JHyn6pgClvvEJaQcJY="
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const scrollToSolutions = () => {
    const solutionsSection = document.getElementById('solutions');
    if (solutionsSection) {
      solutionsSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Images */}
      <div className="absolute inset-0 w-full h-full">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            {slides[currentSlide].title}
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            {slides[currentSlide].subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="primary" size="lg" className="min-w-48" onClick={scrollToSolutions}>
              {t('hero.optimizeWithAI')}
            </Button>
            <Button variant="outline" size="lg" className="min-w-48 border-white text-white hover:bg-white hover:text-gray-900" onClick={scrollToAbout}>
              {t('hero.learnMore')}
            </Button>
          </div>
        </div>
        
        {/* Slide Indicators */}
        <div className="flex justify-center items-center gap-2 mt-12">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide ? 'w-8 bg-white' : 'w-2 bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
